<template>
  <div
    id="import-wallet-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-[600px] max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-semibold text-base uppercase">Import wallet</h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent rounded-lg text-sm w-6 h-6 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
            @click="this.modal.hide()"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div class="p-4">
          <textarea
            v-model="inputModel"
            rows="7"
            class="p-2.5 w-full text-sm bg-transparent rounded-xl border border-gray-400 focus:outline-none focus:ring-0"
            :placeholder="`Private Key 1\nPrivate Key 2\nPrivate Key 3\n...`"
          ></textarea>
          <div class="mt-1.5 flex justify-end">
            <div
              class="inline-block bg-gray-700 shadow shadow-blue-500 hover:shadow-blue-400 px-4 py-1.5 text-sm font-bold rounded-xl cursor-pointer text-gray-300"
              @click="this.submit"
            >
              Import
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite";
import { mapActions, mapGetters } from "vuex";
import { ethers } from "ethers";
import { Keypair, PublicKey } from "@solana/web3.js";
import bs58 from "bs58";

export default {
  name: "ImportWalletModal",
  data() {
    return {
      modal: null,
      inputModel: "",
    };
  },
  computed: {
    ...mapGetters("wallet", ["network"]),
    open() {
      return this.$store.state.importWallet.open;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
  methods: {
    ...mapActions("wallet", ["import"]),
    ...mapActions("importWallet", ["show", "hide"]),
    async submit() {
      const privateKeys = this.inputModel
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line);
      if (privateKeys.length > 0) {
        switch (this.network) {
          case "solana":
            return await this.handleSolana(privateKeys);
          case "ethereum":
          case "base":
          case "bsc":
          default:
            return await this.handleEthereum(privateKeys);
        }
      } else {
        this.$store.commit("toast/add", {
          type: "danger",
          title: "Please enter the private key to import.",
        });
      }
    },
    async handleEthereum(privateKeys) {
      const importWallets = [];
      for (let i = 0; i < privateKeys.length; i++) {
        let privateKey = privateKeys[i];
        if (privateKey.length === 64) {
          privateKey = "0x" + privateKey;
        }
        try {
          const wallet = new ethers.Wallet(privateKey);
          importWallets.push({
            address: wallet.address,
            privateKey: privateKey,
          });
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      await this.import(importWallets);
    },
    async handleSolana(privateKeys) {
      const importWallets = [];
      for (let i = 0; i < privateKeys.length; i++) {
        let privateKey = privateKeys[i];
        try {
          const wallet = Keypair.fromSecretKey(
            new Uint8Array(bs58.decode(privateKey))
          );
          if (PublicKey.isOnCurve(wallet.publicKey.toBuffer())) {
            importWallets.push({
              address: wallet.publicKey.toBase58(),
              privateKey: privateKey,
            });
          }
          // eslint-disable-next-line no-empty
        } catch (e) {
          console.log(e);
        }
      }
      await this.import(importWallets);
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("import-wallet-modal"), {
      placement: "center",
      backdropClasses:
        "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
      onHide: () => {
        this.hide();
      },
    });
  },
  beforeUnmount() {
    this.hide();
  },
};
</script>
